import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { actions } from '../../../../model';
import styles from './style.css';

import copyId from '../../../../utils/copyId';

class DevList extends React.PureComponent {
    static propTypes = {
        devSearchValueUpdate: PropTypes.func,
        devGroupHideStateUpdate: PropTypes.func,
        devGroupHideState: PropTypes.object,
        devSearchValue: PropTypes.string,
        devChips: PropTypes.array,
        devListIsShow: PropTypes.bool,
        chips: PropTypes.array,
        openDialogCallback: PropTypes.func,
    };

    searchHandle = e => {
        this.props.devSearchValueUpdate(e.target.value);
    };
    transfromData(data, chips, value) {
        const newData = data.filter(item => (item.id + item.title).includes(value));
        const result = {};

        for (const item of newData) {
            if (typeof result[item.type] === 'undefined') {
                result[item.type] = [];
            }
            result[item.type].push({
                ...item,
                matchingChips: chips.filter(
                    chip =>
                        `${chip.id}` === `${item.id}` &&
                        `${chip.type}` === `${chip.type}` &&
                        `${item.title}` === `${chip.title}`,
                ),
            });
        }

        return result;
    }
    triggerHandle(key) {
        this.props.devGroupHideStateUpdate({ [key]: !this.props.devGroupHideState[key] });
    }
    copyHandle(item) {
        copyId(item);
    }
    openDialog(item) {
        window.scrollTo({ top: item.rect.top });
        this.props.openDialogCallback(item);
    }
    renderList(data) {
        const { devGroupHideState } = this.props;

        return Object.keys(data).map(key => {
            return (
                <f-div key={key} class={styles.group}>
                    <f-div
                        class={devGroupHideState[key] ? styles.groupTitle : styles.groupTitleOpen}
                        onClick={() => {
                            this.triggerHandle(key);
                        }}>
                        <f-span class={devGroupHideState[key] ? styles.arrow : styles.arrowOpen} />
                        {key}
                    </f-div>
                    <f-div class={devGroupHideState[key] ? styles.groupList : styles.groupListOpen}>
                        {data[key].map((item, index) => {
                            return (
                                <f-div key={index} class={styles.listItem}>
                                    <f-div class={styles.listTitle}>
                                        ({item.id}) {item.title ? `${item.title}|` : ''}
                                        {item.key}
                                        {item.matchingChips.length > 1 ? `[${item.matchingChips.length}]` : ''}
                                    </f-div>
                                    <f-div class={styles.listTools}>
                                        {item.matchingChips.length <= 0 ? (
                                            <f-span
                                                class={styles.iconMask}
                                                title="复制碎片id"
                                                onClick={() => {
                                                    this.copyHandle(item);
                                                }}
                                            />
                                        ) : null}
                                        {item.matchingChips.length > 0 ? (
                                            <f-span
                                                class={styles.iconEdit}
                                                title="跳转到有配置的碎片的位置"
                                                onClick={() => {
                                                    this.openDialog(item.matchingChips[0]);
                                                }}
                                            />
                                        ) : null}
                                    </f-div>
                                </f-div>
                            );
                        })}
                    </f-div>
                </f-div>
            );
        });
    }
    render() {
        const { devSearchValue, devChips, chips } = this.props;

        return (
            <f-div class={this.props.devListIsShow ? styles.listContainerShow : styles.listContainer}>
                <f-div class={styles.devTitle}>开发查看的碎片列表</f-div>
                <f-div class={styles.searchBox}>
                    <input type="input" value={devSearchValue} onChange={this.searchHandle} placeholder="输入过滤词" />
                </f-div>
                <f-div class={styles.listWrap}>
                    <f-div class={styles.listBody}>
                        {this.renderList(this.transfromData(devChips, chips, devSearchValue))}
                    </f-div>
                </f-div>
            </f-div>
        );
    }
}

const mapStateToProps = state => ({
    devChips: state.devChips,
    chips: state.chips,
    listIsShow: state.uiState.listIsShow,
    devListIsShow: state.uiState.devListIsShow,
    devGroupHideState: state.devGroupHideState,
    devSearchValue: state.devSearchValue,
});

const mapDispatchToProps = dispatch => ({
    devSearchValueUpdate: value => dispatch(actions.devSearchValueUpdate(value)),
    devGroupHideStateUpdate: data => dispatch(actions.devGroupHideStateUpdate(data)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(DevList);
